export interface OrganizationDetails {
  readonly id: string; // current aka child organization in relation to `parentOrganizationId`
  readonly parentOrganizationId: string;
  readonly name: string;
  readonly countryCode: string;
  readonly type: string;
  readonly status: OrganizationStatus;
  readonly createdOn: string;
}

export enum OrganizationStatus {
  Active = "Active",
  InActive = "Inactive"
}
